Object.defineProperty(exports,"__esModule",{value:true});exports.fixtureComplianceStateData=exports.positionComplianceStateData=undefined;var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};

var _moment=require('moment');var _moment2=_interopRequireDefault(_moment);
var _types=require('./types');
var _complianceState=require('./complianceState');function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}

var positionComplianceStateData=exports.positionComplianceStateData=function positionComplianceStateData(position){
var rules=position.ruleIds?position.ruleIds.toRefArray():[];

var outOfComplianceRules=(0,_complianceState.getOutOfComplianceRules)(rules);

var typeData=
outOfComplianceRules.length===0?
{
complianceStateType:_types.ComplianceStatus.COMPLIANT,
complianceStateTitle:'Compliant',
complianceStateActuals:[],
complianceStateActions:[],
complianceStateReasons:[]}:

{
complianceStateType:_types.ComplianceStatus.NON_COMPLIANT,
complianceStateTitle:'Not Compliant',
complianceStateActuals:outOfComplianceRules.
map(function(_ref){var actual=_ref.actual;return actual;}).
filter(function(r){return r;}),
complianceStateActions:outOfComplianceRules.
map(function(_ref2){var action=_ref2.action;return action;}).
filter(function(r){return r;}),
complianceStateReasons:outOfComplianceRules.
map(function(_ref3){var description=_ref3.description;return description;}).
filter(function(r){return r;})};


return _extends({},
typeData,{
complianceStateSince:position.complianceStatusUpdatedAt?
(0,_moment2.default)(position.complianceStatusUpdatedAt).format('MMM D YYYY hh:mm A'):
null,
complianceStateMessage:null});

};

var fixtureComplianceStateData=exports.fixtureComplianceStateData=function fixtureComplianceStateData(fixture){
var rules=fixture.ruleIds?fixture.ruleIds.toRefArray():[];

var outOfComplianceRules=(0,_complianceState.getOutOfComplianceRules)(rules);
var typeData=
outOfComplianceRules.length===0?
{
complianceStateType:_types.ComplianceStatus.COMPLIANT,
complianceStateTitle:'Compliant',
complianceStateActuals:[],
complianceStateActions:[],
complianceStateReasons:[]}:

{
complianceStateType:_types.ComplianceStatus.NON_COMPLIANT,
complianceStateTitle:'Not Compliant',
complianceStateActuals:outOfComplianceRules.
map(function(_ref4){var actual=_ref4.actual;return actual;}).
filter(function(r){return r;}),
complianceStateActions:outOfComplianceRules.
map(function(rule){return rule.action;}).
filter(function(r){return r;}),
complianceStateReasons:outOfComplianceRules.
map(function(_ref5){var description=_ref5.description;return description;}).
filter(function(r){return r;})};


return _extends({},
typeData,{
complianceStateSince:fixture.complianceStatusUpdatedAt?
(0,_moment2.default)(fixture.complianceStatusUpdatedAt).format('MMM D YYYY hh:mm A'):
null,
complianceStateMessage:null});

};